import { render, staticRenderFns } from "./centerMap2.vue?vue&type=template&id=24c9deec&scoped=true"
import script from "./centerMap2.vue?vue&type=script&lang=js"
export * from "./centerMap2.vue?vue&type=script&lang=js"
import style0 from "./centerMap2.vue?vue&type=style&index=0&id=24c9deec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c9deec",
  null
  
)

export default component.exports